<template>
  <!--  评论管理-->
  <div id="commentList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
<!--            <span>ID</span>-->
            <input @keyup.enter="getList(1)" placeholder="ID" class="allInput" type="number" v-model="postData.Id">
          </p>
          <p>
<!--            <span>内容名称</span>-->
            <input @keyup.enter="getList(1)" placeholder="内容名称" class="allInput" type="text" v-model="postData.ContentTitle">
          </p>
          <p>
<!--            <span>内容分类</span>-->
            <abbr class="d_i">
              <allSelect :chooseData="allcontent" :needReturn="'id'" :placeholder="'请选择内容分类（可多选）'" :matchValue="'typeName'" :showValue="'{{typeName}}'" :multiple="true" v-model="postData.ContentTypeId">
              </allSelect>
            </abbr>
          </p>
          <p>
<!--            <span>状态</span>-->
            <abbr class="d_i">
              <allSelect :chooseData="messageStateList" :needReturn="'id'" :placeholder="'请选择状态'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.Status">
              </allSelect>
            </abbr>
          </p>
          <p v-if="onSearch">
<!--            <span>评论人</span>-->
            <input @keyup.enter="getList(1)" placeholder="评论人" class="allInput" type="text" v-model="postData.CreatorName">
          </p>
          <p v-if="onSearch">
<!--            <span>部门</span>-->
            <input @keyup.enter="getList(1)" placeholder="部门" class="allInput" type="text" v-model="postData.Org_Acronym">
          </p>
          <p v-if="onSearch">
<!--            <span class="d_i">评论时间</span>-->
            <cander v-model="postData.Startdate" :className="'allInput'" placeholderName="评论开始时间"  class="d_i" style="vertical-align: middle"></cander>
            <abbr class="d_i">-</abbr>
            <cander :minDate="postData.Startdate" v-model="postData.Enddate" :className="'allInput'" placeholderName="评论结束时间"  class="d_i" style="vertical-align: middle"></cander>
          </p>
        </div>
        <div style="width: auto">
          <span class="colorCH c_p" style="text-decoration: underline" @click="tewoSearch()">{{onSearch ? '快速搜索':'高级搜索'}}</span>
          <button @click="getList(1)" class="redButton">
            <i class="icon iconfont iconsousuo"></i>
            <span>搜索</span>
          </button>
          <button class="cancelButtonTwo m_r_10" @click="EmptyList()">清空</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th class="t_c" width="20px"></th>
            <th>ID</th>
            <th>内容名称</th>
            <th>评论</th>
            <th class="t_c">内容分类</th>
            <th class="t_c">评论人</th>
            <th>部门</th>
            <th>评论时间</th>
            <th>状态</th>
            <th class="t_c">操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myList">
            <td class="t_c"><i v-if="item.status !== 2 && item.status !== 3 && item.canApprove && nowApp.roles.indexOf('ContentOwner') >= 0" class="dote"></i></td>
            <td width="10%">{{item.id}}</td>
            <td width="20%" class="NoWrap" style="max-width: 150px" :title="item.contentTitle">{{item.contentTitle}}</td>
            <td width="20%" class="NoWrap" style="max-width: 150px" :title="item.comments">{{item.comments}}</td>
            <td class="t_c">{{item.contentTypeName}}</td>
            <td style="max-width: 100px" class="t_c NoWrap" :title="item.creatorName" >{{item.creatorName}}</td>
            <td width="15%" class="NoWrap" style="max-width: 100px">{{item.org_Acronym}}</td>
            <td>{{item.creationTime}}</td>
            <td :class="item.status === 1 && item.canApprove && nowApp.roles.indexOf('ContentOwner') >= 0? 'colorRed' : ''">{{returnStatus(item.status)}}</td>
            <td width="5%" style="text-decoration:underline #408DEB;" class="colorBlue t_c" v-if="nowApp.roles.indexOf('ContentOwner') >= 0">
              <div v-if="!item.canApprove">
                <i  @click="viewApproval(item)" class="c_p">查看</i>
              </div>
              <div v-else>
                <i  @click="viewApproval(item)"  v-if="item.status === 0 || item.status === 1" class="c_p">审批</i><i  @click="viewApproval(item)"  v-if="item.status === 2 || item.status === 3" class="c_p">查看</i>
              </div>
            </td>
            <td width="5%" style="text-decoration:underline #408DEB;" class="colorBlue t_c" v-else>
              <i  @click="viewApproval(item)" class="c_p">查看</i>
            </td>
            <!--            <td><div class="icon more iconfont icongengduo moreOperations">-->
            <!--              <ul>-->
            <!--                <li>查看</li>-->
            <!--                <li @click="editList()">编辑</li>-->
            <!--                <li>删除</li>-->
            <!--              </ul>-->
            <!--            </div></td>-->
          </tr>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    <!--内容列表-新建内容-->
    <model v-if="newModel" :buttonType="(modelStatus ===2 || modelStatus === 3) ? 3 : 0" :title="'评论审批'" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div>
        <ul class="allUL">
          <li>
            <span>ID</span> <abbr>{{signleModel.id}}</abbr>
          </li>
          <li><span>内容名称</span> <abbr>{{signleModel.contentTitle}}</abbr>
          </li>
          <li><span>评论内容</span><abbr class="senceClass"><span style="word-break: break-all" v-html="signleModel.comments"></span></abbr></li>
          <li><span>是否可见</span>
            <input v-model="signleModel.status" type="radio" :value="2" class="allRadio" id="radio1" name="radio2" :disabled="modelStatus ===2 || modelStatus === 3 || nowApp.roles.indexOf('ContentOwner') < 0"/>
            <label for="radio1"></label><span>是</span>
            <input v-model="signleModel.status" type="radio" :value="3" class="allRadio" id="radio2" name="radio2" :disabled="modelStatus ===2 || modelStatus === 3 || nowApp.roles.indexOf('ContentOwner') < 0"/>
            <label for="radio2"></label><span>否</span>
          </li>
        </ul>
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'commentList',
  data () {
    return {
      isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      canSee: true,
      signleModel: {},
      modelStatus: 0,
      postData: {
        Id: '',
        ContentTitle: '',
        ContentTypeId: '',
        Startdate: '',
        Enddate: '',
        Org_Acronym: '',
        CreatorName: '',
        Status: -1,
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      },
      onSearch: false,
      coverShow: false,
      newModel: false,
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      myList: [],
      allcontent: JSON.parse(window.sessionStorage.getItem('allContentType')),
      allcontent2: JSON.parse(window.localStorage.getItem('canEditList')),
      messageStateList: [
        {
          id: -1,
          name: '全部'
        },
        {
          id: 1,
          name: '未审批'
        },
        {
          id: 2,
          name: '可见'
        },
        {
          id: 3,
          name: '不可见'
        }
      ]
    }
  },
  created () {
    // this.getconTypeList()
    // this.getMessageStatus()
    this.getList(1)
    console.log(this.nowApp)
  },
  methods: {
    returnStatus (statue) {
      if (statue === 0) {
        return '未审批'
      }
      if (statue === 1) {
        return '未审批'
      }
      if (statue === 3) {
        return '不可见'
      }
      if (statue === 2) {
        return '可见'
      }
    },
    getMessageStatus () {
      this.$axiox.getNomalData('/api/application/api/content/messageState').then(msg => {
        this.messageStateList = JSON.parse(JSON.stringify(msg))
      })
    },
    // getconTypeList (pageIndex) {
    //   this.postData.pageIndex = pageIndex
    //   let url = this.$commonJs.returnQuery('/api/contentType/all', {pageIndex: 1, pageSize: 99999})
    //   this.$axiox.get(url).then(msg => {
    //     this.allcontent = JSON.parse(JSON.stringify(msg.result.items))
    //     this.allcontent2 = JSON.parse(JSON.stringify(msg.result.items))
    //   })
    // },
    getList (pageIndex) {
      this.postData.pageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      if (data.Startdate === '') {
        delete data['Startdate']
      }
      if (data.Enddate === '') {
        delete data['Enddate']
      }
      if (data.Id === '') {
        delete data['Id']
      }
      if (data.Status === '') {
        delete data['Status']
      }
      if (data.ContentTypeId === '') {
        delete data['ContentTypeId']
      }
      let url = this.$commonJs.returnQuery('/api/content/comment/Manage/PagedList', data)
      this.$axiox.get(url).then(msg => {
        this.myList = msg.result.items
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.result.totalCount / this.postData.pageSize)
        this.totalCount = msg.result.totalCount
      })
      console.log(this.postData)
    },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    // 新建
    editToUrl (status) {
      this.modelStatus = status
      this.newModel = true
    },
    editList () {
      this.$router.push({
        name: 'ContentReleaseList'
      })
    },
    viewApproval (item) {
      if (this.nowApp.roles.indexOf('ContentOwner') < 0 || !item.canApprove) {
        this.modelStatus = 2
      } else {
        this.modelStatus = item.status
      }
      this.$axiox.get('/api/content/comment/detail?commentId=' + item.id).then(p => {
        this.signleModel = JSON.parse(JSON.stringify(item))
        this.signleModel.comments = p.result.comment
        this.newModel = true
      })
    },
    confirModel () {
      if (this.signleModel.status !== 2 && this.signleModel.status !== 3) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择是否可见',
          stayTime: 5
        })
        return
      }
      if (this.signleModel.status === 2) {
        this.canSee = true
      } else if (this.signleModel.status === 3) {
        this.canSee = false
      }
      this.$axiox.put('/api/content/comment/review?commentId=' + this.signleModel.id + '&status=' + (this.canSee ? 'Approval' : 'Reject')).then(p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '审批成功',
          stayTime: 5
        })
        this.getList(1)
        this.newModel = false
      })
    },
    cancelModel () {
      this.newModel = false
    },
    EmptyList () {
      this.postData.Id = ''
      this.postData.ContentTitle = ''
      this.postData.ContentTypeId = ''
      this.postData.Status = ''
      this.postData.CreatorName = ''
      this.postData.Org_Acronym = ''
      this.postData.Startdate = ''
      this.postData.Enddate = ''
    }
  }
}
</script>

<style scoped>
.allUL li span{
  width: 60px;
}
.allUL li > abbr {
  display: inline-block;
  width: 70%;
  white-space: normal;
  vertical-align: text-top;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/commentList.vue